var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dm-set-password mb-5" }, [
    _c("div", { staticClass: "form-group row" }, [
      _c(
        "label",
        { staticClass: "col-xl-3 col-lg-3 col-form-label text-right" },
        [_vm._v("New Password")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-xl-9 col-lg-9" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.user_data.password,
              expression: "user_data.password"
            }
          ],
          staticClass: "form-control",
          attrs: { type: "password", value: "", placeholder: "New password" },
          domProps: { value: _vm.user_data.password },
          on: {
            keyup: function($event) {
              return _vm.$emit("changesMade")
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.user_data, "password", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c("small", { staticClass: "fw-bold" }, [
          _vm._v("Password must be at least 8 characters long.")
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group row" }, [
      _c(
        "label",
        { staticClass: "col-xl-3 col-lg-3 col-form-label text-right" },
        [_vm._v("Verify Password")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-xl-9 col-lg-9" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.user_data.password_confirmation,
              expression: "user_data.password_confirmation"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "password",
            value: "",
            placeholder: "Verify password"
          },
          domProps: { value: _vm.user_data.password_confirmation },
          on: {
            keyup: function($event) {
              return _vm.$emit("changesMade")
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.user_data,
                "password_confirmation",
                $event.target.value
              )
            }
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }